import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parse a subscription_plan value like "elite_monthly" into its parts.
 * Handles legacy values like "monthly" (no tier) and "free".
 * Returns { tier, period, display }.
 */
const TIER_NAMES = ['explorer', 'essential', 'professional', 'elite'];
const PERIOD_NAMES = ['weekly', 'monthly', 'quarterly', 'annual'];

export function parsePlan(planValue) {
  if (!planValue || planValue === 'free') {
    return { tier: 'free', period: null, display: 'Free' };
  }

  const lower = planValue.toLowerCase();

  // New format: "elite_monthly", "professional_quarterly", etc.
  for (const tier of TIER_NAMES) {
    for (const period of PERIOD_NAMES) {
      if (lower === `${tier}_${period}`) {
        const tierLabel = tier.charAt(0).toUpperCase() + tier.slice(1);
        const periodLabel = period.charAt(0).toUpperCase() + period.slice(1);
        return { tier, period, display: `${tierLabel} (${periodLabel})` };
      }
    }
  }

  // Legacy format: just a period like "monthly"
  if (PERIOD_NAMES.includes(lower)) {
    const periodLabel = lower.charAt(0).toUpperCase() + lower.slice(1);
    return { tier: null, period: lower, display: periodLabel };
  }

  // Unknown format — return capitalised
  return { tier: null, period: null, display: planValue.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) };
}

/**
 * Get just the tier name from a plan value (e.g. "elite_monthly" → "Elite").
 * Returns "Free" for free/missing plans.
 */
export function getTierName(planValue) {
  const { tier } = parsePlan(planValue);
  if (!tier || tier === 'free') return 'Free';
  return tier.charAt(0).toUpperCase() + tier.slice(1);
}

/**
 * Get just the base tier id from a plan value (e.g. "elite_monthly" → "elite").
 */
export function getBaseTier(planValue) {
  const { tier } = parsePlan(planValue);
  return tier || 'free';
}
